import styled, { css, keyframes } from "styled-components";

interface LoaderDivProps {
  show?: boolean;
  filled?: boolean;
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export default styled.div.withConfig({
  shouldForwardProp: (p) => !["show", "filled"].includes(p),
})<LoaderDivProps>`
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background-color: color-mix(
    in srgb,
    var(--palette-common-black) 50%,
    transparent
  );
  z-index: 9999999999;
  color: var(--neutral-white);
  padding-left: 240px;

  @media (max-width: 1279px) {
    padding-left: 0px;
  }

  ${(props) =>
    props.filled
      ? css`
          background-color: var(--neutral-white);
        `
      : css`
          background-color: color-mix(
            in srgb,
            var(--palette-common-black) 50%,
            transparent
          );
        `}
  ${(props) =>
    props.show === true
      ? css`
          animation: ${fadeIn} 0.3s ease;
          display: flex;
        `
      : css`
          animation: ${fadeOut} 0.3s ease;
          display: none;
        `}
`;
